export default __webpack_public_path__ + "static/media/screen12.170d6abd.svg";